<template>
	<div class="mp-wrap">
		<div class="mp-header">
			<div class="mp-top">
				<button class="icon-btn" @click="$emit('back')">
					<img src="@/assets/mobile/icon/back.png" alt="Back">
				</button>
				<button class="icon-btn" @click="$emit('close')">
					<img src="@/assets/mobile/icon/close.png" alt="Close">
				</button>
			</div>
			<div class="mp-breadcrumb">
				<span class="mp-crumb" @click="$emit('back')">Collection</span>
				<span class="mp-crumb-active">{{ sectionLabel }}</span>
			</div>
		</div>

		<div class="mp-content" ref="scrollContainer">
			<div class="mp-grid" :style="{ height: gridHeight + 'px' }">
				<div v-for="(item, idx) in visibleItems" :key="idx" class="mp-card" @click="openItem(item)">
					<img :src="item.image" :alt="item.label">
					<div class="mp-title">{{ item.label }}</div>
				</div>
			</div>
			<div ref="sentinel" class="mp-sentinel"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MenuProduct',
		props: {
			tab: {
				type: String,
				default: ''
			},
			section: {
				type: String,
				default: ''
			},
			items: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				observer: null,
				visibleItems: [],
				page: 0,
				pageSize: 4,
				gridHeight: 'auto' // 动态高度
			}
		},
		computed: {
			sectionLabel() {
				const map = {
					table: 'TABLE',
					seating: 'SEATING',
					accessories: 'ACCESSORIES'
				}
				return map[this.section] || 'TABLE'
			}
		},
		methods: {

			calculateGridHeight() {
				this.$nextTick(() => {
					const cards = this.$el.querySelectorAll('.mp-card')
					if (cards.length === 0) {
						this.gridHeight = 'auto'
						return
					}

					// 计算每行高度
					const cardHeight = cards[0].offsetHeight || 260
					const rowCount = Math.ceil(cards.length / 2) // 每行2个卡片
					const gap = 4 // gap 4px
					const padding = 30 // padding-bottom 30px

					const totalHeight = rowCount * cardHeight + (rowCount - 1) * gap + padding

					this.gridHeight = totalHeight
					console.log('Grid height set to:', totalHeight, 'cards:', cards.length, 'rows:', rowCount)
				})
			},
			loadMore() {
				if (this.page * this.pageSize >= this.items.length) return
				const start = this.page * this.pageSize
				const end = start + this.pageSize
				this.visibleItems = this.visibleItems.concat(this.items.slice(start, end))
				this.page += 1

				// 加载完成后重新计算高度
				this.calculateGridHeight()
			},

			resetAndLoad() {
				this.page = 0
				this.visibleItems = []
				this.loadMore()
			},
			onIntersect(entries) {
				const entry = entries[0]
				if (entry && entry.isIntersecting) {
					this.loadMore()
				}
			},
			openItem(item) {
				this.$router.push({
					path: '/m/product',
					query: {
						CategoryID: item.CategoryID
					}
				})
				this.$emit('close')
			},
			forceScroll() {
				// 强制设置滚动
				this.$nextTick(() => {
					const container = this.$refs.scrollContainer
					if (container) {
						container.style.overflowY = 'scroll'
						container.style.webkitOverflowScrolling = 'touch'
						container.style.height = 'auto'
						container.style.maxHeight = 'none'
					}
				})
			}
		},
		mounted() {
			this.resetAndLoad()
			this.forceScroll()

			const root = this.$el.closest('.m-sheet') || null
			this.observer = new IntersectionObserver(this.onIntersect, {
				root,
				threshold: 0.1
			})
			if (this.$refs.sentinel) {
				this.observer.observe(this.$refs.sentinel)
			}

			// 监听窗口大小变化
			window.addEventListener('resize', this.forceScroll)
		},
		beforeDestroy() {
			if (this.observer) {
				this.observer.disconnect()
				this.observer = null
			}
			window.removeEventListener('resize', this.forceScroll)
		},
		watch: {
			items: {
				handler() {
					this.resetAndLoad()
					this.forceScroll()
				},
				immediate: true
			},
			section() {
				this.resetAndLoad()
				this.forceScroll()
			}
		}
	}
</script>

<style scoped>
	.mp-wrap {
		display: block;
		/* 改为 block，不用 flex */
		padding: 0 !important;
		padding-top: 32px !important;
	}

	.mp-header {
		position: sticky;
		top: 0;
		background: #fff;
		z-index: 10;
	}

	.mp-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;
		padding: 0 23px;
	}

	.mp-breadcrumb {
		display: flex;
		align-items: center;
		gap: 65px;
		padding: 62px 23px 25px 23px;
	}

	.mp-crumb {
		font-size: 13px;
		font-weight: 500;
		color: #999;
	}

	.mp-crumb-active {
		font-size: 14px;
		font-weight: 500;
		color: #000;
	}

	/* 移除 mp-content 的滚动，让父容器滚动 */
	.mp-content {
		/* 不需要滚动样式 */
	}

	.mp-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 4px;
		padding: 0 15px;
		padding-bottom: 40px;
	}

	.mp-card {
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding-bottom: 20px;
	}

	.mp-card img {
		object-fit: cover;
		width: 100%;
		height: 245px;
	}

	.mp-title {
		font-size: 10px;
		color: #000;
	}

	.mp-sentinel {
		width: 100%;
		height: 1px;
	}

	.icon-btn {
		background: none;
		border: none;
		padding: 0;
		height: 15px;
		width: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		color: #000;
	}
</style>